<template>
    <li :class="['login__link', {'active-link': isLoginBoxOpen}, theme]">
        <template v-if="!isLoggedIn">
            <span class="login__link-label" @click="toggleLogin">{{ $t("Menu.login") }}</span>
            <ul class="login__box" v-show="isLoginBoxOpen">
                <LoginSSO />
            </ul>
        </template>
        <template v-else>
            <LoginProfileDropDown :theme="theme"/>
        </template>
    </li>
</template>

<script>
    import LoginSSO from 'components/user/LoginSSO'
    import LoginFormHelper from 'components/shared/mixins/loginFormHelper'
    import LoginProfileDropDown from 'components/layout/loginprofilemenu/LoginProfileDropDown'
    import { mapGetters } from 'vuex'
    export default {
        components: {
            LoginSSO,
            LoginProfileDropDown
        },
        mixins: [ LoginFormHelper ],
        inject: ['headerTheme'],
        computed: {
            ...mapGetters({
                isLoginBoxOpen: 'User/getIsLoginBoxOpen',
                isLoggedIn: 'isLoggedIn'
            }),
            theme () {
                return this.headerTheme()
            }
        },
        created () {
            window.addEventListener('click', this.closeLogin)
        },
        beforeDestroy () {
            window.removeEventListener('click', this.closeLogin)
        }
    }
</script>

<style lang="scss" scoped>
.login {
    &__link {
        @include router-link;
        &.dark {
            color: $white;
        }
    }

    &__link-label {
        cursor: pointer;
        font-family: Nunito-Bold, sans-serif;
    }

    &__box {
        top: 52px;
        position: absolute;
        border: solid 1px $orange;
        background: $white;
        z-index: 1;
        transition: all 0.1s ease-in-out 0s, visibility 0s linear 0.1s, z-index 0s linear 0.01s;
        right: 0;
    }
}
</style>
